module.exports = __webpack_public_path__ + "static/media/favicon.ce270c86.ico";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/peterpan/favicon.ico
// module id = 795
// module chunks = 0